async function checkErrors(resp) {
    if(resp.ok) return resp;

    let errorMsg = `ERROR ${resp.status} (${resp.statusText})`;
    let serverText = await resp.text();
    if(serverText) errorMsg = `${errorMsg}: ${serverText}`;

    var error = new Error(errorMsg);
    error.response = resp;
    throw error;
}

async function toJSON(resp) {
    const result = await resp.text();
    if(result) return JSON.parse(result);
}

async function send(url, method, data, contentType) {
    let options = {
        method: method,
        headers: {},
        mode: 'cors'
    };
    if (data) options.body = JSON.stringify(data);
    if (contentType) options.headers['Content-Type'] = contentType;

    let result = await fetch(url, options);

    await checkErrors(result);
    return await toJSON(result);
}

export function postAsync(url, data) {
    return send(url, 'POST', data, 'application/json');
}

export function putAsync(url, data) {
    return send(url, 'PUT', data, 'application/json');
}

export function patchAsync(url, data) {
    return send(url, 'PATCH', data, 'application/merge-patch+json');
}

export function getAsync(url) {
    return send(url, 'GET');
}

export function deleteAsync(url) {
    return send(url, 'DELETE');
}

export function saveToLocalStorage(data, destination) {
    let file = JSON.stringify(data);
    window.localStorage.setItem(destination, file);
}

export function sleep(ms) {
    return new Promise(resolve => setTimeout(resolve, ms));
}